import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "../pages/dashboard";
import Client from "../pages/operation/client";
import Order from "../pages/operation/order";
import OrderService from "../pages/operation/orderService";
import OrderInvestmentTransaction from "../pages/operation/orderInvestmentTransaction";
import RiskControlSetting from "../pages/operation/riskControlSetting";
import InvestmentTransactionSetting from "../pages/operation/investmentTransactionSetting";
import FileBackupSyncSetting from "../pages/operation/fileBackupSyncSetting";
import DocumentSetting from "../pages/management/documentSetting";
import OrderRenewal from "../pages/consultant/orderRenewal";
import OrderPending from "../pages/consultant/orderPending";
import Product from "../pages/operation/product";
import Provider from "../pages/operation/provider";
import ProductCategory from "../pages/operation/productCategory";
import ProductType from "../pages/operation/productType";
import ProductTypeGroup from "../pages/operation/productTypeGroup";
import ApprovalFundList from "../pages/operation/approvalFundList";
import User from "../pages/operation/user";
import UserRole from "../pages/operation/userRole";
import UserRoleEdit from "../pages/operation/userRoleEdit";
import UserGroup from "../pages/operation/userGroup";
import CommissionOverridingPlan from "../pages/management/commissionOverridingPlan";
import AllowancePlan from "../pages/management/allowancePlan";
import PointType from "../pages/management/pointType";
import PointTransaction from "../pages/management/pointTransaction";
import LevelType from "../pages/management/levelType";
import PromotionTrack from "../pages/management/promotionTrack";
import AllowanceList from "../pages/management/allowanceList";
import TicketTypes from "../pages/management/ticketTypes";
import ExtraFields from "../pages/management/extraFields";
import OrderServiceType from "../pages/management/orderServiceType";
import ExchangeRate from "../pages/management/exchangeRate";
import Ticket from "../pages/ticket";
import MyTicket from "../pages/myTicket";
import CommissionSchedule from "../pages/management/commissionSchedule";
import PayrollPayment from "../pages/consultant/payrollPayment";
import WalletPage from "../pages/consultant/walletPage";
import WalletList from "../pages/management/walletList";
import ConsultantProduct from "../pages/consultant/product";
import CommissionStatement from "../pages/account/commissionStatement";
import Payroll2 from "../pages/account/payroll2";
import DataMigration from "../pages/management/dataMigration";
import ProfolioImport from "../pages/management/profolioImport";
import MyTeam from "../pages/consultant/myTeam";
import Home from "../pages/home";
import CalendarEvent from "../pages/management/calendarEvent";
import ConsultantIncentive from "../pages/management/consultantIncentive";
import ClientPromotion from "../pages/management/clientPromotion";
import TopRanking from "../pages/management/topRanking";
import Incentive from "../pages/account/incentive";
import BankAccount from "../pages/bankAccount";
import ResetPassword from "../pages/resetPassword";
import MyProfile from "../pages/myProfile";
import MSetting from "../pages/management/setting";
import OSetting from "../pages/operation/setting";
import Organization from "../pages/management/organization";
import ApiKey from "../pages/management/apiKey";
import CronJob from "../pages/management/cronJob";
import DebitNote from "../pages/gi/debitNote";
import Quotation from "../pages/gi/quotation";
import Renewal from "../pages/gi/renewal";
import GIMatchPayment from "../pages/gi/matchPayment";
import GISettlement from "../pages/gi/settlement";
import BankTransaction from "../pages/account/bankTransaction";
import Ir56mSetting from "../pages/account/ir56mSetting";
import HsbcMriSetting from "../pages/account/hsbcMriSetting";
import BankAccountDetail from "../pages/bankAccountDetail";
import AccountingHome from "../pages/accounting";
import ChartOfAccounts from "../pages/accounting/chartOfAccounts";
import JournalEntries from "../pages/accounting/journalEntries";
import FiscalPeriods from "../pages/accounting/fiscalPeriods";
import TrialBalance from "../pages/accounting/trialBalance";
import FinancialStatements from "../pages/accounting/financialStatements";
import SubledgerReconciliation from "../pages/accounting/subledgerReconciliation";
import PostingRules from "../pages/accounting/postingRules";
import OpeningBalance from "../pages/accounting/openingBalance";
import AIPrompt from "../pages/aiPrompt";
import AIWorkFlow from "../pages/aiWorkFlow";
import AIRequest from "../pages/aiRequest";
import DataFeed from "../pages/dataFeed";
import GIReport from "../pages/giReport";
import QuoRequest from "../pages/gi/quoRequest";
import ConsultantQuoRequest from "../pages/gi/consultantQuoRequest";
import Cpd from "../pages/operation/cpd";
import PersonalTradingAccountPage from "../pages/management/personalTradingAccount";
import Quiz from "../pages/operation/quiz";
import QuizEditor from "../pages/operation/quizEditor";
import QuizDetail from "../pages/operation/quizDetail";
import QuizResults from "../pages/operation/quizResults";
import QuizStats from "../pages/operation/quizStats";
import MyQuizzes from "../pages/consultant/myQuizzes";
import QuizTake from "../pages/consultant/quizTake";
import QuizResult from "../pages/consultant/quizResult";
import McaProcess from "../pages/management/mcaProcess";
import McaProcessEditor from "../pages/management/mcaProcessEditor";
import Approval from "../pages/operation/approval";
import NotificationRules from "../pages/management/notificationRules";
import NotificationRuleEdit from "../pages/management/notificationRuleEdit";
import NotificationLogs from "../pages/management/notificationLogs";
import NotificationCenter from "../pages/notificationCenter";
import NotificationPreferences from "../pages/notificationPreferences";
import McaRequest from "../pages/mcaRequest";
import McaRequestDetail from "../pages/mcaRequestDetail";
import MyCPD from "../pages/consultant/myCPD";
import SubmitCpdCertificate from "../pages/consultant/submitCpdCertificate";
import ConsultantReport from "../pages/consultant/report";
import BidList from "../pages/management/bidList";
import Report from "../pages/report";
import SearchPage from "../pages/searchPage";
import FileManagers from "../pages/fileManagers";
import CompensationSetting from "../pages/compensationSetting";
import Team from "../pages/management/team";
import Company from "../pages/management/company";
import ConsultantProvider from "../pages/consultant/provider";
import NotFound from "../pages/notFound";

export function authenticatedRouteElements() {
  return (
    <>
      <Route index path="/" element={<Home />} />
      <Route index path="/home" element={<Home />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/fileManagers" element={<FileManagers />} />
      <Route path="operation/client" element={<Client role="OPERATION" />} />
      <Route path="gi/client" element={<Client role="OPERATION" />} />
      <Route path="management/client" element={<Client role="OPERATION" />} />
      <Route path="account/client" element={<Client role="OPERATION" />} />
      <Route path="/m/setting" element={<MSetting />} />
      <Route path="/o/setting" element={<OSetting />} />
      <Route path="/resetPassword" element={<ResetPassword />} />
      <Route path="/myProfile" element={<MyProfile />} />
      <Route path="operation/order" element={<Order role="OPERATION" />} />
      <Route path="operation/orderRenewal" element={<OrderRenewal role="OPERATION" />} />
      <Route path="gi/order" element={<Order role="GI-OPERATION" />} />
      <Route path="management/order" element={<Order role="MANAGEMENT" />} />
      <Route path="management/orderRenewal" element={<OrderRenewal role="MANAGEMENT" />} />
      <Route path="management/commissionSchedule" element={<CommissionSchedule />} />
      <Route path="management/aiPrompt" element={<AIPrompt />} />
      <Route path="management/aiRequest" element={<AIRequest />} />
      <Route path="management/aiWorkflow" element={<AIWorkFlow />} />
      <Route path="account/order" element={<Order role="MANAGEMENT" />} />
      <Route path="operation/orderService" element={<OrderService role="OPERATION" />} />
      <Route path="/management/orderService" element={<OrderService role="MANAGEMENT" />} />
      <Route path="consultant/orderService" element={<OrderService role="CONSULTANT" />} />
      <Route
        path="operation/orderInvestmentTransaction"
        element={<OrderInvestmentTransaction role="OPERATION" />}
      />
      <Route
        path="management/orderInvestmentTransaction"
        element={<OrderInvestmentTransaction role="MANAGEMENT" />}
      />
      <Route
        path="consultant/orderInvestmentTransaction"
        element={<OrderInvestmentTransaction role="CONSULTANT" />}
      />
      <Route path="management/product" element={<Product />} />
      <Route path="gi/product" element={<Product />} />
      <Route path="operation/product" element={<Product />} />
      <Route path="account/product" element={<Product />} />
      <Route path="operation/provider" element={<Provider />} />
      <Route path="gi/provider" element={<Provider />} />
      <Route path="management/compensationSetting" element={<CompensationSetting />} />
      <Route path="management/provider" element={<Provider />} />
      <Route path="operation/productCategory" element={<ProductCategory />} />
      <Route path="gi/productCategory" element={<ProductCategory />} />
      <Route path="management/productCategory" element={<ProductCategory />} />
      <Route path="operation/productTypeGroup" element={<ProductTypeGroup />} />
      <Route path="gi/productTypeGroup" element={<ProductTypeGroup />} />
      <Route path="management/productTypeGroup" element={<ProductTypeGroup />} />
      <Route path="operation/productType" element={<ProductType />} />
      <Route path="gi/productType" element={<ProductType />} />
      <Route path="operation/approvalFundList" element={<ApprovalFundList />} />
      <Route path="gi/approvalFundList" element={<ApprovalFundList />} />
      <Route path="management/approvalFundList" element={<ApprovalFundList />} />
      <Route
        path="operation/riskControlSetting"
        element={<RiskControlSetting />}
      />
      <Route
        path="management/riskControlSetting"
        element={<RiskControlSetting />}
      />
      <Route
        path="operation/investmentTransactionSetting"
        element={<InvestmentTransactionSetting />}
      />
      <Route
        path="management/investmentTransactionSetting"
        element={<InvestmentTransactionSetting />}
      />
      <Route
        path="operation/fileBackupSyncSetting"
        element={<FileBackupSyncSetting />}
      />
      <Route
        path="management/fileBackupSyncSetting"
        element={<FileBackupSyncSetting />}
      />
      <Route
        path="operation/documentSetting"
        element={<DocumentSetting />}
      />
      <Route
        path="management/documentSetting"
        element={<DocumentSetting />}
      />
      <Route path="operation/cpd" element={<Cpd />} />
      <Route path="management/cpd" element={<Cpd />} />
      <Route
        path="management/personalTradingAccount"
        element={<PersonalTradingAccountPage />}
      />
      <Route path="operation/quiz" element={<Quiz />} />
      <Route path="operation/quiz/stats" element={<QuizStats />} />
      <Route path="operation/quiz/new" element={<QuizEditor />} />
      <Route path="operation/quiz/:id/edit" element={<QuizEditor />} />
      <Route path="operation/quiz/:id/results" element={<QuizResults />} />
      <Route path="operation/quiz/:id" element={<QuizDetail />} />
      <Route path="management/quiz" element={<Quiz />} />
      <Route path="management/quiz/stats" element={<QuizStats />} />
      <Route path="management/quiz/new" element={<QuizEditor />} />
      <Route path="management/quiz/:id/edit" element={<QuizEditor />} />
      <Route path="management/quiz/:id/results" element={<QuizResults />} />
      <Route path="management/quiz/:id" element={<QuizDetail />} />
      <Route path="consultant/myQuizzes" element={<MyQuizzes />} />
      <Route path="consultant/myQuizzes/:id/result" element={<QuizResult />} />
      <Route path="consultant/myQuizzes/:id" element={<QuizTake />} />
      <Route path="management/myQuizzes" element={<MyQuizzes />} />
      <Route path="management/myQuizzes/:id/result" element={<QuizResult />} />
      <Route path="management/myQuizzes/:id" element={<QuizTake />} />
      <Route path="management/mcaProcess" element={<McaProcess />} />
      <Route path="management/mcaProcess/new" element={<McaProcessEditor />} />
      <Route path="management/mcaProcess/:id" element={<McaProcessEditor />} />
      <Route path="operation/approval" element={<Approval />} />
      <Route path="management/approval" element={<Approval />} />
      <Route path="management/notificationRules" element={<NotificationRules />} />
      <Route path="management/notificationRules/new" element={<NotificationRuleEdit />} />
      <Route path="management/notificationRules/:id" element={<NotificationRuleEdit />} />
      <Route path="management/notificationLogs" element={<NotificationLogs />} />
      <Route path="notifications" element={<NotificationCenter />} />
      <Route path="settings/notificationPreferences" element={<NotificationPreferences />} />
      <Route path="mca/requests" element={<McaRequest />} />
      <Route path="mca/requests/:id" element={<McaRequestDetail />} />
      <Route path="consultant/myTeam" element={<MyTeam />} />
      <Route path="operation/user" element={<User role="OPERATION" />} />
      <Route path="operation/userRole" element={<UserRole />} />
      <Route path="operation/userRole/edit" element={<UserRoleEdit />} />
      <Route path="gi/user" element={<User role="OPERATION" />} />
      <Route path="management/user" element={<User role="MANAGEMENT" />} />
      <Route path="account/user" element={<User role="MANAGEMENT" />} />
      <Route path="hr/user" element={<User role="HR" />} />
      <Route path="operation/userGroup" element={<UserGroup />} />
      <Route path="account/userGroup" element={<UserGroup />} />
      <Route path="management/calendarEvent" element={<CalendarEvent />} />
      <Route path="management/commissionOverridingPlan" element={<CommissionOverridingPlan />} />
      <Route path="management/team" element={<Team />} />
      <Route path="management/company" element={<Company />} />
      <Route path="management/ticketTypes" element={<TicketTypes />} />
      <Route path="management/extraFields" element={<ExtraFields />} />
      <Route path="management/orderServiceType" element={<OrderServiceType />} />
      <Route path="m/bankAccountDetail" element={<BankAccountDetail />} />
      <Route path="account/bankAccountDetail" element={<BankAccountDetail />} />
      <Route path="management/allowance" element={<AllowanceList />} />
      <Route path="management/allowancePlan" element={<AllowancePlan />} />
      <Route path="management/pointType" element={<PointType />} />
      <Route path="management/pointTransaction" element={<PointTransaction />} />
      <Route path="management/levelType" element={<LevelType />} />
      <Route path="management/promotionTrack" element={<PromotionTrack />} />
      <Route path="account/allowance" element={<AllowanceList />} />
      <Route path="account/allowancePlan" element={<AllowancePlan />} />
      <Route path="management/exchangeRate" element={<ExchangeRate />} />
      <Route path="management/profolioImport" element={<ProfolioImport />} />
      <Route path="management/dataMigration/*" element={<DataMigration />} />
      <Route path="account/commissionStatement" element={<CommissionStatement />} />
      <Route path="management/commissionStatement" element={<CommissionStatement />} />
      <Route path="account/payroll" element={<Payroll2 />} />
      <Route path="management/payroll" element={<Payroll2 />} />
      <Route path="management/payroll2" element={<Navigate to="/management/payroll" replace />} />
      <Route path="account/incentive" element={<Incentive />} />
      <Route path="management/incentive" element={<Incentive />} />
      <Route path="account/bankTransaction" element={<BankTransaction />} />
      <Route path="account/accounting" element={<AccountingHome />} />
      <Route path="management/accounting" element={<AccountingHome />} />
      <Route path="account/chartOfAccounts" element={<ChartOfAccounts />} />
      <Route path="management/chartOfAccounts" element={<ChartOfAccounts />} />
      <Route path="account/journalEntries" element={<JournalEntries />} />
      <Route path="management/journalEntries" element={<JournalEntries />} />
      <Route path="account/fiscalPeriods" element={<FiscalPeriods />} />
      <Route path="management/fiscalPeriods" element={<FiscalPeriods />} />
      <Route path="account/trialBalance" element={<TrialBalance />} />
      <Route path="management/trialBalance" element={<TrialBalance />} />
      <Route path="account/financialStatements" element={<FinancialStatements />} />
      <Route path="management/financialStatements" element={<FinancialStatements />} />
      <Route path="account/subledgerReconciliation" element={<SubledgerReconciliation />} />
      <Route path="management/subledgerReconciliation" element={<SubledgerReconciliation />} />
      <Route path="account/postingRules" element={<PostingRules />} />
      <Route path="management/postingRules" element={<PostingRules />} />
      <Route path="account/openingBalance" element={<OpeningBalance />} />
      <Route path="management/openingBalance" element={<OpeningBalance />} />
      <Route path="account/ir56mSetting" element={<Ir56mSetting />} />
      <Route path="management/ir56mSetting" element={<Ir56mSetting />} />
      <Route path="account/hsbcMriSetting" element={<HsbcMriSetting />} />
      <Route path="management/hsbcMriSetting" element={<HsbcMriSetting />} />
      <Route path="management/bankTransaction" element={<BankTransaction />} />
      <Route path="consultant/client" element={<Client role="CONSULTANT" />} />
      <Route path="consultant/quotation" element={<Quotation role="CONSULTANT" />} />
      <Route path="consultant/order" element={<Order role="CONSULTANT" />} />
      <Route path="consultant/debitNote" element={<DebitNote role="CONSULTANT" />} />
      <Route path="consultant/renewal" element={<Renewal role="CONSULTANT" />} />
      <Route path="consultant/orderPending" element={<OrderPending />} />
      <Route path="consultant/orderRenewal" element={<OrderRenewal role="CONSULTANT" />} />
      <Route path="consultant/payrollPayment" element={<PayrollPayment />} />
      <Route path="gi/quoRequest" element={<QuoRequest role="OPERATION" />} />
      <Route path="management/consultantIncentive" element={<ConsultantIncentive />} />
      <Route path="management/clientPromotion" element={<ClientPromotion />} />
      <Route path="consultant/wallet" element={<WalletPage />} />
      <Route path="consultant/provider" element={<ConsultantProvider role="CONSULTANT" />} />
      <Route path="consultant/product" element={<ConsultantProduct />} />
      <Route path="management/topRanking" element={<TopRanking />} />
      <Route path="management/organization" element={<Organization />} />
      <Route path="management/apiKey" element={<ApiKey />} />
      <Route path="management/cronJob" element={<CronJob />} />
      <Route path="consultant/quoRequest" element={<ConsultantQuoRequest />} />
      <Route path="consultant/myCPD" element={<MyCPD />} />
      <Route path="consultant/myCPD/submit" element={<SubmitCpdCertificate />} />
      <Route path="consultant/report" element={<ConsultantReport />} />
      <Route path="management/myCPD" element={<MyCPD />} />
      <Route path="management/bids" element={<BidList />} />
      <Route path="management/wallet" element={<WalletList />} />
      <Route path="account/bids" element={<BidList />} />
      <Route path="gi/quotation" element={<Quotation />} />
      <Route path="m/gi/quotation" element={<Quotation />} />
      <Route path="gi/renewal" element={<Renewal role="MANAGEMENT" />} />
      <Route path="m/gi/renewal" element={<Renewal role="MANAGEMENT" />} />
      <Route path="gi/debitNote" element={<DebitNote />} />
      <Route path="m/gi/debitNote" element={<DebitNote />} />
      <Route path="gi/matchPayment" element={<GIMatchPayment />} />
      <Route path="m/gi/matchPayment" element={<GIMatchPayment />} />
      <Route path="gi/settlement" element={<GISettlement />} />
      <Route path="m/gi/settlement" element={<GISettlement />} />
      <Route path="management/bankAccount" element={<BankAccount />} />
      <Route path="account/bankAccount" element={<BankAccount />} />
      <Route path="/ticket" element={<Ticket />} />
      <Route path="/chat" element={<MyTicket />} />
      <Route path="/dataFeed" element={<DataFeed />} />
      <Route path="/management/dataFeed" element={<DataFeed />} />
      <Route path="/report" element={<Report />} />
      <Route path="/gi/report" element={<GIReport />} />
      <Route path="/account/report" element={<Report />} />
      <Route path="/management/report" element={<Report />} />
      <Route index path="/search" element={<SearchPage />} />
      <Route path="*" element={<NotFound />} />
    </>
  );
}

export function AppRouteTree() {
  return <Routes>{authenticatedRouteElements()}</Routes>;
}

/** @deprecated Use authenticatedRouteElements() inside a parent Route */
export function AuthenticatedRouteElements() {
  return authenticatedRouteElements();
}
